import { Brand } from '@/components/Brand';
import { Button } from '@/components/ui/button';

export function SignInScreen({
  onSignIn,
  error,
  waitingForBrowser,
}: {
  onSignIn: () => void;
  error: string | null;
  waitingForBrowser: boolean;
}) {
  return (
    <main className="scanlines bg-hud-grid grid h-full place-items-center p-6">
      <div className="cut-tr w-full max-w-md bg-bg-2/85 p-8 shadow-[inset_0_0_0_1px_var(--color-line)]">
        <Brand size="lg" />
        <p className="hud-label mt-8">Studio access</p>
        <h1 className="mt-2 font-display text-xl font-black tracking-[0.04em] uppercase">Sign in to the studio</h1>
        <p className="mt-2 text-muted">Use the Google account on The Hive&apos;s studio list.</p>
        <Button size="lg" className="mt-6 w-full" onClick={onSignIn} disabled={waitingForBrowser}>
          Sign in with Google
        </Button>
        {waitingForBrowser ? (
          <p className="mt-4 font-mono text-xs text-yellow" role="status">
            Finish signing in in your browser. Hive will come back to the front when you&apos;re done.
          </p>
        ) : null}
        {error ? (
          <p className="mt-4 border-l-2 border-red bg-red/10 px-3 py-2 font-mono text-xs text-[#ffc2cd]" role="alert">
            {error}
          </p>
        ) : null}
      </div>
    </main>
  );
}
